// src/pages/My404Component.js
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import {
  Box,
  Typography,
  Button,
  Container,
  Grid,
  Paper,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { auth } from "../../../reducers/authSlice"; // make sure the path is correct

const My404Component = ({ auth: { isAuth, loading }, authVerify }) => {
  const userPermissions = useSelector((state) => state?.auth?.permissions);
  const userAll = useSelector((state) => state?.auth);
  console.log(isAuth, "auth404", userAll)
  const [verified, setVerified] = useState(false);

  const hasDashboardPermission = userPermissions?.some(
    (perm) => perm?.frontendUrl === "/admin/dashboard"
  );


  useEffect(() => {
    const checkToken = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        // Call the Redux auth action to verify token
        const res = await authVerify();
        if (res?.payload?.isAuth) {
          setVerified(true);
        }
      }
    };
    checkToken();
  }, [authVerify]);

  // Redirect immediately if token is valid
  if ((verified || (isAuth && !loading)) && hasDashboardPermission) {
    return <Navigate to="/admin/dashboard" replace />;
  } else if (isAuth && !loading && !hasDashboardPermission) {
    return <Navigate to="/admin/home" replace />;
  }


  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={6}
          sx={{
            p: 5,
            borderRadius: 3,
            textAlign: "center",
            backgroundColor: "#fff",
          }}
        >
          <Grid container spacing={4} alignItems="center" justifyContent="center">
            <Grid item xs={12}>
              <ErrorOutlineIcon sx={{ fontSize: 80, color: "error.main" }} />
              <Typography variant="h2" color="primary" gutterBottom>
                404
              </Typography>
              <Typography variant="h5" gutterBottom>
                Oops! Page not found.
              </Typography>
              <Typography variant="body1" color="text.secondary">
                The page you are looking for might have been removed,
                <br />
                had its name changed, or is temporarily unavailable.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" color="text.secondary">
                &copy; {new Date().getFullYear()} All rights reserved.
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  authVerify: () => dispatch(auth()), // call your auth thunk to verify token
});

export default connect(mapStateToProps, mapDispatchToProps)(My404Component);
